module.exports = __webpack_public_path__ + "img/ribu-logo.ba7b40ce.png";